var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "title": $t("rs7et37", "选择部门/成员"),
      "width": "900px",
      "mask-closable": false
    },
    on: {
      "on-cancel": _vm.close
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function () {
        return [_c('Button', {
          attrs: {
            "loading": _vm.loading
          },
          on: {
            "click": _vm.close
          }
        }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
          attrs: {
            "type": "primary",
            "loading": _vm.loading
          },
          on: {
            "click": _vm.onSubmit
          }
        }, [_vm._v(` ${$t("e32z2", "保存")} `)])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('PositionNotice', {
    attrs: {
      "type": _vm.position.tagValue
    }
  }), _vm.tabs.length > 0 ? _c('ProChioseAddressBook', {
    attrs: {
      "visible": _vm.visible,
      "tabs": _vm.tabs
    },
    model: {
      value: _vm.checkedList,
      callback: function ($$v) {
        _vm.checkedList = $$v;
      },
      expression: "checkedList"
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };